import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { DocumentListItem } from '../../../../../types';

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  handleDelete: () => void;
  selectedDocument: DocumentListItem | null;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({
  open,
  onClose,
  handleDelete,
  selectedDocument,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Document</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete "{selectedDocument?.fileName}"?
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleDelete} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
